/* istanbul ignore file -- @preserve */
import { useEffect, useRef, useState } from 'react';

export function useThrottledValue<T>(value: T, ms: number): T {
  const [throttled, setThrottled] = useState(value);
  const lastRef = useRef(0);
  useEffect(() => {
    const now = Date.now();
    if (now - lastRef.current >= ms) {
      setThrottled(value);
      lastRef.current = now;
    } else {
      const timer = setTimeout(() => {
        setThrottled(value);
        lastRef.current = Date.now();
      }, ms);
      return () => clearTimeout(timer);
    }
  }, [value, ms]);
  return throttled;
}
